import { Descriptions } from 'antd';
import React from 'react';
import SkeletonInput from 'antd/lib/skeleton/Input';

const BillOfMaterialInfoLoading = ({ active }: { active: boolean }) => {
  return (
    <>
      <Descriptions
        title="Bill of Material"
        style={{
          backgroundColor: 'white',
          padding: '16px',
          borderRadius: '0.25rem',
        }}
      >
        <Descriptions.Item label="BOM No">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="PRODER no">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="PO no">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Required Date">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Date Entry">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Shipment Date">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Revision">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Remarks">
          <SkeletonInput active={active} />
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default BillOfMaterialInfoLoading;
